/** @jsxImportSource @emotion/react */

import { Container, IconContainer } from './styles';

import classNames from 'classnames';
import { EditIcon } from 'lucide-react';
import { UDText } from 'ud-ui/components';
import { useState } from 'react';
import { DivProps } from 'typings';
import BackgroundItem from './background-item';

type IProps = DivProps & {
  img?: string;
  color: string;
  colorName: string;
};

function LogoView(props: IProps) {
  const { img, color, colorName, onClick, ...rest } = props;
  const [isHover, setIsHover] = useState(false);
  return (
    <div {...rest}>
      <UDText type={'footnote'}>Ваш логотип</UDText>
      <Container onClick={onClick} onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
        <BackgroundItem color={color} colorName={colorName} img={img} />
        <IconContainer className={classNames({ show: isHover })}>
          <EditIcon />
        </IconContainer>
      </Container>
    </div>
  );
}

export default LogoView;
